import { render, staticRenderFns } from "./BaseLearningPathPicker.vue?vue&type=template&id=c31fd63a&"
import script from "./BaseLearningPathPicker.vue?vue&type=script&lang=js&"
export * from "./BaseLearningPathPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports